import { useEffect, useRef, useState } from 'react';
import { useRouterState } from '@tanstack/react-router';

export default function TopLoadingBar() {
  const isLoading = useRouterState({ select: (s) => s.status === 'pending' });

  const [width, setWidth] = useState(0);
  const [opacity, setOpacity] = useState(0);
  const completeTimer = useRef<ReturnType<typeof setTimeout> | null>(null);

  useEffect(() => {
    if (completeTimer.current) clearTimeout(completeTimer.current);

    if (isLoading) {
      setOpacity(1);
      setWidth(0);
      const t = setTimeout(() => setWidth(85), 20);
      return () => clearTimeout(t);
    } else {
      setWidth(100);
      completeTimer.current = setTimeout(() => {
        setOpacity(0);
        completeTimer.current = setTimeout(() => setWidth(0), 300);
      }, 200);
    }
  }, [isLoading]);

  return (
    <div
      className="bg-background-accent"
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        height: '2px',
        width: `${width}%`,
        opacity,
        zIndex: 9999,
        transition: isLoading
          ? 'width 4s cubic-bezier(0.1, 0.05, 0, 1), opacity 0.2s'
          : 'width 0.2s ease-out, opacity 0.3s 0.2s',
        pointerEvents: 'none',
      }}
    />
  );
}
